"use strict";
exports.__esModule = true;
exports.assignFromAccountRaw = exports.assignToAccountRaw = exports.fromSolanaResourcesRaw = exports.toSolanaResourcesRaw = void 0;
function toSolanaResourcesRaw(resources) {
    return {
        stakes: JSON.stringify(resources.stakes)
    };
}
exports.toSolanaResourcesRaw = toSolanaResourcesRaw;
function fromSolanaResourcesRaw(resourcesRaw) {
    return {
        stakes: JSON.parse(resourcesRaw.stakes)
    };
}
exports.fromSolanaResourcesRaw = fromSolanaResourcesRaw;
function assignToAccountRaw(account, accountRaw) {
    var solanaAccount = account;
    if (solanaAccount.solanaResources) {
        accountRaw.solanaResources = toSolanaResourcesRaw(solanaAccount.solanaResources);
    }
}
exports.assignToAccountRaw = assignToAccountRaw;
function assignFromAccountRaw(accountRaw, account) {
    var solanaResourcesRaw = accountRaw.solanaResources;
    if (solanaResourcesRaw)
        account.solanaResources =
            fromSolanaResourcesRaw(solanaResourcesRaw);
}
exports.assignFromAccountRaw = assignFromAccountRaw;
//# sourceMappingURL=serialization.js.map